/**
 * 入力欄（input / select / textarea）共通の見た目。Figma: form-field。
 * focus は枠 2px（border 1px + 内側 ring 1px）。枠を太くすると中身が 1px ずれるため ring で足す。
 * エラー時の枠は globals.css の .error_input が上書きする。
 */
export const fieldClassName =
  'w-full rounded-lg border border-line bg-surface px-4 py-3 text-base leading-body text-ink placeholder:text-ink-subtle focus:border-line-inverse focus:outline-none focus:ring-1 focus:ring-inset focus:ring-line-inverse'
